<template>
  <v-form ref="form" class="d-flex gap-5" :class="{ edit }" lazy-validation v-model="valid">
    <div class="flex-grow-1 d-grid grid-col-md-1-1-1 gap-4">
      <template v-if="edit || ($vuetify.breakpoint.smAndDown ? show : true)">
        <BaseInput
          v-model="dateStartFormatted"
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['data-nachala']"
          prepend-inner-icon="today"
          :placeholder="localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybrano']"
          view
        />
        <BaseInput
          v-model="dateEndFormatted"
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['data-kontsa']"
          prepend-inner-icon="today"
          :placeholder="localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybrano']"
          view
        />
      </template>
      <div :class="$vuetify.breakpoint.smAndDown ? 'first-row d-grid grid-col-1-auto gap-2' : ''">
        <BaseInput
          v-model="item.employees"
          type="autocomplete"
          multiple
          :items="item.employees_list"
          :item-value="(i) => i.id"
          :item-text="(i) => (i.user ? i.user.first_name + ' ' + i.user.last_name : null)"
          :label="localStorage.translations.pages.sales_project['planned_resources-labels']['podrazdelenie']"
          prepend-inner-icon="today"
          :placeholder="localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybranny']"
          view
          chips
          smallChips
        >
          <template v-slot:viewValue>
            <div class="mt-2 d-flex gap-1 flex-wrap">
              <template v-if="item.employees_list.length">
                <template v-for="item in item.employees_list">
                  <router-link
                    :to="{
                    name: 'PersonalAreaEmployee',
                    params: { userId: item.user.id },
                  }"
                    class="primary white--text f12 rounded-pill px-2 py-1"
                    style="white-space: nowrap"
                    :key="item.id"
                  >
                    {{ item.user.first_name + ' ' + item.user.last_name }}
                  </router-link>
                </template>
              </template>
              <div class="f14 secondary--text" v-else>
                {{ localStorage.translations.pages.sales_project['planned_resources-time_period-inputs']['ne-vybranny'] }}
              </div>
            </div>
          </template>
        </BaseInput>
        <v-btn icon @click="show = !show" v-if="$vuetify.breakpoint.smAndDown && !edit" color="primary" class="align-self-center">
          <svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            preserveAspectRatio="xMidYMid meet"
            viewBox="1 1 10 10"
            :class="show ? 'icon-rotate' : ''"
          >
            <path
              fill="currentColor"
              d="M7.854 5.854a.5.5 0 1 0-.708-.708L6 6.293L4.854 5.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5ZM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0ZM6 2a4 4 0 1 1 0 8a4 4 0 0 1 0-8Z"/>
          </svg>
        </v-btn>
      </div>
    </div>
    <div class="d-grid grid-col-md-1-1 gap-5" v-if="edit">
      <ProjectPlannedResourcesWorkTypePeriodModal
        v-if="edit"
        :create="false"
        :reverse="true"
        :projectWorkTypeId="item.project_work_type.id"
        :workTypeId="item.project_work_type.work_type.id"
        :workTypePeriodId="item.id"
      />
      <DeleteModal
        type="workClientProjectsWorkTypePeriod"
        :item="item"
        :text="
          localStorage.translations.pages.sales_project['planned_resources-time_period-delete'][
            'udalit-vremennyy-period'
          ]
        "
        :textSecond="
          localStorage.translations.pages.sales_project['planned_resources-time_period-delete'][
            'text2'
          ]
        "
        :textCheckbox="
          localStorage.translations.pages.sales_project['planned_resources-time_period-delete'][
            'udalit-vmeste-s-dokladami'
          ]
        "
      />
    </div>
  </v-form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DeleteModal from 'components/DeleteModal'
import ProjectPlannedResourcesWorkTypePeriodModal from './ProjectPlannedResourcesWorkTypePeriodModal'

export default {
  name: 'ProjectPlannedResourcesWorkTypePeriod',
  components: {
    DeleteModal,
    ProjectPlannedResourcesWorkTypePeriodModal,
  },
  props: ['item', 'itemKey', 'workTypeList', 'workTypeId', 'server', 'edit'],
  data: () => ({
    valid: false,
    dateStartFormatted: null,
    dateEndFormatted: null,
    show: false,
  }),
  created() {
    this.dateStartFormatted = this.formatDate(this.item.start_date)
    this.dateEndFormatted = this.formatDate(this.item.end_date)
  },
  updated() {},
  watch: {
    'item.start_date'(val) {
      this.dateStartFormatted = this.formatDate(this.item.start_date)
    },
    'item.end_date'(val) {
      this.dateEndFormatted = this.formatDate(this.item.end_date)
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    computedDateFormatted() {
      return this.formatDate(this.item.start_date)
      return this.formatDate(this.item.end_date)
    },
  },
  methods: {
    ...mapActions('employee', ['onEmployeeListGroupsAndWorkTypes']),
    ...mapActions('workClientProjectsWorkTypePeriod', [
      'onWorkClientProjectsWorkTypePeriodCreate',
      'onWorkClientProjectsWorkTypePeriodAll_project',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    checkDate() {
      if (this.item.start_date > this.item.end_date) {
        this.item.end_date = null
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>

<style scoped lang="scss">
.first-row {
  grid-row-start: 1;
}

svg {
  transition-duration: 0.3s;

  &.icon-rotate {
    transition-duration: 0.3s;
    transform: rotateZ(-180deg);
    transform-origin: center;
  }
}
</style>